import { gql } from '@apollo/client';

export default gql`
  mutation provisionallyUpdateSeat($reference: String!, $seats: [InputSeats]) {
    provisionallyUpdateSeat(reference: $reference, seats: $seats) {
      reference
      status
    }
  }
`;
